export default __webpack_public_path__ + "static/media/shutterstock_3.253bb946.jpg";